var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("table", { staticClass: "table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.overproductionData, function(item, index) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.sellBrandName))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.productionBrandName))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.mealName))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.sizeName))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.deliveryDate))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _vm._v(_vm._s(item.orderQuantity))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: item.overproductionQuantity,
                      expression: "item.overproductionQuantity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", min: "0", disabled: item.disabled },
                  domProps: { value: item.overproductionQuantity },
                  on: {
                    keypress: _vm.numbersOnly,
                    change: function($event) {
                      return _vm.save(item)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        item,
                        "overproductionQuantity",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.reservedQuantity))]),
              _vm._v(" "),
              _c("td", {
                staticClass: "text-center",
                domProps: { innerHTML: _vm._s(_vm.warehouse(item)) }
              }),
              _vm._v(" "),
              _c("td", {
                staticClass: "text-center",
                domProps: { innerHTML: _vm._s(_vm.sum(item)) }
              }),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.diffProductionList(item)) }
                }),
                _c("br"),
                _vm._v(" "),
                item.productionListDate
                  ? _c("small", { staticStyle: { color: "#aaa" } }, [
                      _vm._v(_vm._s(item.productionListDate))
                    ])
                  : _vm._e()
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Lp")]),
        _vm._v(" "),
        _c("th", [_vm._v("Marka sprzedażowa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Marka produkcyjna")]),
        _vm._v(" "),
        _c("th", [_vm._v("PPK")]),
        _vm._v(" "),
        _c("th", [_vm._v("Wielkość")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data dostawy")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Suma sprzedaży")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("Zaplanowana nadprodukcja")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Zarezerwowane")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Magazyn")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Wyprodukować")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Od aktualizacji")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a344e68", { render: render, staticRenderFns: staticRenderFns })
  }
}